import { render, staticRenderFns } from "./BasesTab.vue?vue&type=template&id=230b6126&"
import script from "./BasesTab.vue?vue&type=script&lang=js&"
export * from "./BasesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports